import { render, staticRenderFns } from "./ModifyGame.vue?vue&type=template&id=5414cd1b&scoped=true"
import script from "./ModifyGame.vue?vue&type=script&lang=js"
export * from "./ModifyGame.vue?vue&type=script&lang=js"
import style0 from "./ModifyGame.vue?vue&type=style&index=0&id=5414cd1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5414cd1b",
  null
  
)

export default component.exports